import { render, staticRenderFns } from "./environment_page.vue?vue&type=template&id=1116b982&scoped=true&"
import script from "./environment_page.vue?vue&type=script&lang=js&"
export * from "./environment_page.vue?vue&type=script&lang=js&"
import style0 from "./environment_page.vue?vue&type=style&index=0&id=1116b982&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1116b982",
  null
  
)

export default component.exports